import React from 'react';
import Modal from 'sub_components/Common/PortalModalNew';
import { BloxButton } from 'styled_components/Common/BloxButton';
export const WindowsPopUp = props => {
	const { onClick } = props;

	return (
		<Modal>
			<div className='browser-message-container'>
				<div className='message-wrapper'>
					<div className='text heading60'>
						{' '}
						I see that you're still using IE.
						<br />
						Please use Chrome, Firefox , Safari or Edge if you want to experience the full
						functionality of our site.
					</div>
					<div className='browser-message-button'>
						<BloxButton
							className='buttons41'
							id='okay'
							text='CONTINUE'
							module='support'
							enabled={true}
							onClick={onClick}
							cypressId='windows-browser'
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
};
